export default __webpack_public_path__ + "static/media/logo-footer.e74abdf1.svg";